import React, { useEffect, useState } from "react";

const MAINT_BG_IMAGE = "https://bizdomfs.blob.core.windows.net/post-image/2d085166-d02b-4aaf-93e5-4c05888c1d61.webp";

const MAINT_CSS = `
  html, body, #root {
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  .maint-root {
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000; /* fills letterbox space so it blends with the image's dark bg */
    position: relative;
    overflow: hidden;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  /* ✅ Full image always visible, never cropped — scales to fit any screen */
  .maint-bg-image {
    width: 100vw;
    height: 100dvh;
    object-fit: contain;
    object-position: center;
    display: block;
  }

  .maint-footer {
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 10.5px;
    color: rgba(255,255,255,0.55);
    letter-spacing: 0.3px;
    z-index: 2;
    pointer-events: none;
  }

  /* ── TABLET ── */
  @media screen and (min-width: 601px) {
    .maint-footer { font-size: 11.5px; bottom: 14px; }
  }

  /* ── DESKTOP ── */
  @media screen and (min-width: 1024px) {
    .maint-footer { font-size: 12.5px; bottom: 18px; }
  }

  /* ── LANDSCAPE MOBILE / SHORT HEIGHT ── */
  @media screen and (max-height: 480px) and (orientation: landscape) {
    .maint-footer { font-size: 9.5px; bottom: 6px; }
  }
`;

if (!document.getElementById("maint-css")) {
  const el = document.createElement("style");
  el.id = "maint-css";
  el.textContent = MAINT_CSS;
  document.head.appendChild(el);
}

function MaintenancePage({ onRetry }) {
  // ── Silent background auto-poll — no visible countdown, just keeps checking ──
  useEffect(() => {
    const poll = setInterval(() => {
      onRetry?.();
    }, 8000);
    return () => clearInterval(poll);
  }, [onRetry]);

  return (
    <div className="maint-root">
      <img
        className="maint-bg-image"
        src={MAINT_BG_IMAGE}
        alt="Website Under Maintenance"
      />

      <div className="maint-footer">
        © {new Date().getFullYear()} Powered by BizDom Solutions
      </div>
    </div>
  );
}

export default MaintenancePage;